import BulkMessagesAPI from '../../api/bulkMessages';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isSending: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAllBulkMessages(_state) {
    return _state.records;
  },
  getBulkMessage: _state => id => {
    return _state.records.find(r => r.id === id);
  },
};

export const actions = {
  fetch: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await BulkMessagesAPI.get();
      commit('SET_BULK_MESSAGES', data);
    } catch (error) {
      // ignore
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, params) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await BulkMessagesAPI.create({ bulk_message: params });
      commit('ADD_BULK_MESSAGE', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...params }) => {
    try {
      const { data } = await BulkMessagesAPI.update(id, { bulk_message: params });
      commit('UPDATE_BULK_MESSAGE', data);
      return data;
    } catch (error) {
      throw error;
    }
  },

  delete: async ({ commit }, id) => {
    try {
      await BulkMessagesAPI.delete(id);
      commit('REMOVE_BULK_MESSAGE', id);
    } catch (error) {
      throw error;
    }
  },

  sendNow: async ({ commit }, id) => {
    commit('SET_UI_FLAG', { isSending: true });
    try {
      const { data } = await BulkMessagesAPI.sendNow(id);
      commit('UPDATE_BULK_MESSAGE', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isSending: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  SET_BULK_MESSAGES(_state, data) {
    _state.records = data;
  },
  ADD_BULK_MESSAGE(_state, data) {
    _state.records.unshift(data);
  },
  UPDATE_BULK_MESSAGE(_state, data) {
    const idx = _state.records.findIndex(r => r.id === data.id);
    if (idx !== -1) {
      _state.records[idx] = data;
    }
  },
  REMOVE_BULK_MESSAGE(_state, id) {
    _state.records = _state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
